import styles from './index.module.less';

interface LoadingProps {
  text?: string;
  isBetterRoomJump?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ text = '加载中...', isBetterRoomJump = false }) => {
  return (
    <div className={styles.fullScreenLoading}>
      <div className={`${styles.spinner} ${isBetterRoomJump ? styles.betterRoomJumpSpinner : ''}`} />
      {isBetterRoomJump && <p className={styles.titleText}>正在跳转中</p>}
      {!!text && <p className={`${styles.text} ${isBetterRoomJump ? styles.betterRoomJumpText : ''}`}>{text}</p>}
    </div>
  );
};

export default Loading;
